module.exports = {
  no: {
    ABOUT_LITERATURE_SEARCH: 'Om litteratursøket',
    ARTICLE: 'Artikkel',
    AUTHORS: 'Forfattere',
    BOOK: 'Bok',
    CATEGORIES: 'Kategorier',
    CATEGORY: 'Kategori',
    DANISH: 'Dansk',
    ENGLISH: 'Engelsk',
    LANGUAGE: 'Språk',
    LOADING: 'Laster',
    NEXT: 'Neste',
    NO_RESULTS: 'Ingen resultater',
    NORWEGIAN_BOKMAAL: 'Norsk (Bokmål)',
    NORWEGIAN_NYNORSK: 'Norsk (Nynorsk)',
    OTHER: 'Annet',
    PREVIOUS: 'Forrige',
    RESEARCHARTICLE: 'Forskningsartikkel',
    RESULTS: 'Resultater',
    SAMI: 'Samisk',
    SEARCH_RESEARCH_LITERATURE: 'Søk blant forskningslitteratur',
    SWEDISH: 'Svensk',
    VIDEO: 'Video'
  }
}



// WEBPACK FOOTER //
// ./src/translations/no.js